import Vue from 'vue'
import Vuex from 'vuex'

import axios from '../tools/http.js'
Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
	state: {
		isCollapse: false, //是否显示首页左侧导航
		admin_info: {}, //当前管理员信息
		order_tj: {}, //订单列表条件
		app_list: [],
	},
	mutations: {
		//显示或隐藏首页导航
		show2hide(state) {
			state.isCollapse = !state.isCollapse
		},
		//更新管理员信息
		updateAdminInfo(state, admin_info) {
			state.admin_info = admin_info
		},
		//更新订单列表条件
		updateOrderTj(state, tj) {
			state.order_tj = tj
		},
		//更新App列表
		updateAppList(state,app_list_temp = []) {
			console.log(app_list_temp)
			//判断是手动更新还是自动更新
			if(app_list_temp) {
				state.app_list = app_list_temp
			
			} else {
				
				axios({
					method: 'get',
					url: global.url + '/v1/app',
				}).then(function(res) {

					if(res.data.error === 0) {
						state.app_list = res.data.data.list
						
					}
				}).catch(function(res) {
				})
			}

		}

	},
	getters: {

	},
	actions: {

	}
})


// WEBPACK FOOTER //
// ./src/vuex/index.js